import { reducerWithInitialState } from 'typescript-fsa-reducers';

import { NAMESPACE } from './constants';
import { setFilter } from './actions';

import { ALL_ORDERS } from '../../../../shared/constants';

export interface State {
    filter: string;
}

export interface OrderListState {
    [NAMESPACE]: {
        view: State;
    };
}

export const INITIAL_STATE: State = {
    filter: ALL_ORDERS,
};

export const reducer = reducerWithInitialState<State>(INITIAL_STATE).case(
    setFilter,
    (state, filter) => ({
        ...state,
        filter,
    }),
);
